module.exports = __webpack_public_path__ + "static/media/desk-cover.17bdbc9a.svg";